<template>
  <div class="exhibitionRecord">
    <el-col class="userinfoList infoPub" style="width: 999px">
      <div class="exhContent" style="padding-bottom:30px;">
        <!-- 搜索组件 -->
<!--        <search-bar-->
<!--          :selectType="ExhIndexType"-->
<!--          :searchInputPlc="searchInputPlc"-->
<!--          :searchSelectPlc="searchSelectPlc"-->
<!--          @changeExhibitionState="toSearch"-->
<!--          @toSearch="toSearch"-->
<!--        ></search-bar>-->
        <div class="prompt-info-text">
          <div class="prompt-infoword"><span v-if="lan == 'ch'">{{language.ticText}}</span></div>
          <div class="prompt-infoword" >{{language.ticTextTwo}}</div>
        </div>
        <div class="tic_table">
          <!-- table -->
          <pub-table :columns="columns" :tableData="cloneTicktsData"
                     :loading="loading" :ticketMan="ticketMan" style="padding-top: 0">
            <!-- 操作按钮 -->
            <template v-slot:action="dataList">
              <el-tooltip class="item" effect="dark" :content="language.givingnotes" placement="top"
              v-if="broadcast_id != '' && dataList.dataList.distribution == 0 && dataList.actionType == '1' && dataList.dataList.exh_state != '3' && dataList.dataList.exhibition_id != 28">
                <el-button

                  size="mini"
                  style="cursor:pointer;
                  outline: none;
                  background:#2b6ff9;
                  border:none;
                  color:#FFFFFF;
                  border-radius:5px;
                  font-size:16px;
                  margin-left: 10px;"
                  @click="givingBtn(dataList)"
                >{{language.giving}}</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="language.recyclingnotes" placement="top" v-else-if="broadcast_id != '' && dataList.dataList.distribution == 0 && dataList.dataList.exhibition_id != 28">
                <!--
                  actionType 1 未分配, 2自己分配的
                  exh_state 1未开始, 2进行中, 3结束 -->
                <el-button
                  v-if="dataList.actionType =='2' && (dataList.dataList.exh_state == '1' || dataList.dataList.exh_state == '6') "
                  size="mini"
                  style="outline: none;background:#f47900;border:none;color:#FFFFFF;border-radius:5px;font-size:16px;margin-left: 10px;"
                  @click="recyclingBtn(dataList)"
                >{{language.recycling}}</el-button>
                <el-button
                    v-else
                    type="primary"
                    size="mini"
                    style="outline: none;background:#0f408a;border:none;color:#fefefe;border-radius:4px;font-size:14px"
                    disabled
                >{{language.recycling}}</el-button>
              </el-tooltip>

            </template>
          </pub-table>
        </div>

        <!-- page -->
        <table-page
          :pageSize="pageSize"
          :layout="layout"
          :pageTotal="pageTotal"
          :currentPage="currentPage"
          @pageChange="pageChange"
        ></table-page>
      </div>
      <!-- 赠送弹窗 -->
      <dialog-pub
        ref="dialogChild"
        :title="title"
        diaWidth="450px"
        :dialogFormVisible="dialogFormVisible"
        class="send-ticket"
      >
        <div style="font-size: 20px;font-weight: bold;margin-bottom: 10px;color: #333333">{{fenpei_title}}</div>
        <el-form style="padding-top:16px;text-align: center" class="tickDialog" :inline="true">
          <el-form-item :label="language.childAccount+':'">
            <el-select
              v-model="selectSubAccount"
              :placeholder="language.exhibitionSelect"
            >
              <el-option
                v-for="(item,index) in subAccountList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="text-align:center;">
            <div class="btnStyle" @click="giving" style="line-height: 40px">{{language.giving}}</div>
          </div>
        </el-form>
      </dialog-pub>
      <!-- 回收弹窗 -->
      <dialog-pub
        ref="recyclingDialogChild"
        :title="title"
        diaWidth="416px"
        :dialogFormVisible="dialogRecycling"
        class="playback"
      >
        <div style="padding-top:16px;" class="tickDialog">
          <div
            style="text-align:center;margin:4px 0 50px 0;font-size:18px;width: 370px;"
          >{{language.doYouConfirm}}{{exhibition_name}}直播间席位 {{recyclingName}} {{language.tickets}}</div>
          <div style="text-align:center">
            <div
              @click="recyclingOk"
              class="btnStyle"
              style="margin:14px 36px 0 0;background:#2b6ef7;display: inline-block;font-size: 16px;"
            >{{language.confirm}}</div>
            <div
              @click="recyclingCancel"
              class="btnStyle"
              style="margin-top:14px;background:#f1f1f1;display: inline-block;color: #333333;font-size: 16px;"
            >{{language.cancel}}</div>
          </div>
        </div>
      </dialog-pub>

      <!--提示添加子账号弹窗-->
      <dialog-pub
        ref="DialogError"
        title=""
        exTop="30vh"
        diaWidth="400px"
        :dialogFormVisible="dialogErrorVisible"
        class="friendTip"
      >
        <div style="text-align: center;font-size: 18px;margin-top: 10px;color: #606266;">{{hintMessage}}</div>
        <div style="text-align:center">
          <div
            v-if="userInfo.account != 1"
            @click="$router.push({path: '/subaccountManagement'})"
            class="btnStyle"
            style="background:#f47900;cursor: pointer;margin-top: 50px;font-size: 16px;width: 150px;"
          >{{language.goAdd}}</div>
          <div
            v-else
            @click="$refs.DialogError.receiveDialogFormVisible = false"
            class="btnStyle"
            style="margin-top: 20px;background:#003F8F;cursor: pointer"
          >{{language.confirm}}</div>
        </div>
      </dialog-pub>
    </el-col>
  </div>
</template>
<script>
import { language } from "../../../language/get";
import {ExhIndexType} from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie"
import {mapGetters} from "vuex";
import {
  getCzExhTicketList,
  getExhTicketGive,
  ExhticketRecovery
} from "../../../api/tickets";
import {isEmpty} from "../../../common/validate";
import { getSubAccount } from "../../../api/subAccount";
import searchBar from "../components/searchbar/searchbar";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
import dialogPub from "../components/dialogpub/dialogpub";
const pubLanguage = language();
export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  components: {
    searchBar,
    pubTable,
    tablePage,
    dialogPub
  },
  data() {
    return {
      fenpei_title:"",
      exhibition_name:"",
      language: language(),
      lan: Cookie.get("lang"),
      subAccountList: [], //子账户列表
      ticketMan:true,
      selectSubAccount: "",
      exhticketUserId: "",
      subAccountId: "",
      //回收
      recyclingName: "",
      title: "",
      dialogFormVisible: false,
      dialogRecycling: false,
      loading: true,
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索相关
      ExhIndexType,
      searchInputPlc: pubLanguage.fairName,
      searchSelectPlc: pubLanguage.state,
      //搜索条件
      getStateCon: null,
      getValCon: null,
      //table 表头
      columns: [],
      ticktsData: [],
      cloneTicktsData: [],
      dialogErrorVisible: false,
      hintMessage: ""
    };
  },

  props: {
    broadcast_id: {
      type: String,
      default: () => {
        return '';
      },
    }
  },
  watch: {
    selectSubAccount(val) {
      this.subAccountId = val;
    },
    // $route() {
    //   this.exhTicketList();
    // }
  },
  methods: {
    giving() {
      let data = {
        token: this.$store.state.user.token,
        exhticket_user_id: this.exhticketUserId,
        giveuserid: this.subAccountId
      };
      getExhTicketGive(data).then(res => {
        if (res.type == "1") {
          this.$message.success({
            message: this.language.giveSuccess,
            offset: 120
          });
          this.exhTicketList();
          this.$refs.dialogChild.receiveDialogFormVisible = false;
        } else {
          if (this.lan == "ch") {
            return this.$message.error({message: res.text, offset: 120})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    },
    //赠送
    givingBtn(val) {
      //当账号为子账号为别人的子账号
      /*if (this.userInfo.account == 1){
        this.hintMessage = this.language.accountError;
        this.$refs.DialogError.receiveTitle = this.language.helpfulHints;
        this.$refs.DialogError.receiveDialogFormVisible = true;
        return;
      }*/
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        currentPage: 1,
        numberPage: 9999
      };
      getSubAccount(data).then(res => {
        if (res.type == "1") {
          if (isEmpty(res.data )) {
            this.subAccountList = [];
            // this.$refs.DialogError.receiveTitle = this.language.helpfulHints2;
            this.hintMessage = this.language.addSub;
            this.$refs.DialogError.receiveDialogFormVisible = true;
            return;
          }
          let subAccountList = [];
          res.data.forEach(item => {
            let obj = {};
            if (this.lan == 'ch') {
              obj.label = item.true_name;
              obj.value = item.user;
            }else{
              obj.label = item.true_name_en;
              obj.value = item.user;
            }

            subAccountList.push(obj);
          });
          this.subAccountList = subAccountList;
          if(this.lan == 'ch'){
            // this.$refs.dialogChild.receiveTitle = `${this.language.givingTitle} ${val.dataList.exh_name} ${this.language.exhSeat}`;
            this.fenpei_title = this.language.givingTitle + " " + val.dataList.exh_name + " " + "直播间席位";
          }
          // else{
          //   this.$refs.dialogChild.receiveTitle = `${this.language.givingTitle} ${val.dataList.exh_name_en} ${this.language.exhSeat}`;
          // }
          this.selectSubAccount = "";
          this.exhticketUserId = val.dataList.exhticket_user_id;
          this.$refs.dialogChild.receiveDialogFormVisible = true;
        } else {
          if (this.lan == "ch") {
            return this.$message.error({message: res.text, offset: 120})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    },
    //回收
    recyclingBtn(val) {
      // this.$refs.recyclingDialogChild.receiveTitle = `${this.language.recycling}${val.dataList.exh_name}${this.language.exhSeat}`;
      this.exhibition_name = val.dataList.exh_name;
      this.recyclingName = val.dataList.ascription_name;
      this.exhticketUserId = val.dataList.exhticket_user_id;
      this.$refs.recyclingDialogChild.receiveDialogFormVisible = true;
    },
    //取消回收
    recyclingCancel() {
      this.$refs.recyclingDialogChild.receiveDialogFormVisible = false;
    },
    recyclingOk() {
      let data = {
        token: this.$store.state.user.token,
        exhticket_user_id: this.exhticketUserId
      };
      ExhticketRecovery(data).then(res => {
        if (res.type == "1") {
          this.exhTicketList();
          this.$refs.recyclingDialogChild.receiveDialogFormVisible = false;
        } else {
          if (this.lan == "ch") {
            return this.$message.error({message: res.text, offset: 120})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    },
    //取消/关闭
    cancel() {
      this.$refs.dialogChild.receiveDialogFormVisible = false;
    },
    //确认修改
    ok() {
      this.editBroadcastList();
    },
    //搜索切换
    toSearch(state, val) {
      this.getStateCon = state;
      this.getValCon = val;
      this.currentPage = 1;
      this.exhTicketList();
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.exhTicketList();
    },
    //展会门票列表
    exhTicketList() {
      this.loading = true;
      const exh_type = this.$route.meta.fn;
      const columns = [
        {
          title: pubLanguage.attributable,
          key: "ascription_name",
          width: "160"
        },
        {
        title: pubLanguage.zhiwei,
        key: "ascription_user_post",
          width: "160"
        },
        {
          title: pubLanguage.findInput,
          key: "ascription_tel",
          width: "230"
        },
        {
          title: pubLanguage.email,
          key: "ascription_email",
          width: "243"
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "170"
        }
        ];
      // const role = {
      //     title: pubLanguage.role,
      //     key: "broadcastTypeName",
      //     width: "70"
      //   };
      // const price = {
      //   title: pubLanguage.price,
      //   key: "exhticket_price",
      //   width: "65"
      // };
      if (exh_type == 1){
        // columns.splice(2,0,price)
        // columns.forEach(item => {
        //   if (item.key == "exhticket_price") {
        //     item.width = 135
        //   }
        // })
         this.columns = columns;
      }else {
        // columns.splice(5,0,role)
        columns.forEach(item => {
          if (item.key == "pay_time"){
            item.width = 203
          }
        })
        this.columns = columns;
      }
      let data = {
        token: this.$store.state.user.token,
        type: this.getStateCon,
        keyword: this.getValCon,
        broadcast_id: this.broadcast_id,
        lan: this.lan,
        broadcast_type: exh_type,
        currentPage: this.currentPage,
        numberPage: this.pageSize
      };

      getCzExhTicketList(data).then(res => {
        if (res.type == "1") {
          if (!res.data) {
            this.ticktsData = [];
            this.cloneTicktsData = [];
            this.pageTotal = 0;
            this.loading = false;
            return false;
          }
          let data = res.data;
          data.forEach(item => {
            if (this.lan == "en") {
              item.exh_name = `${item.exh_name_en}`;
              item.broadcast_name = `${item.broadcast_name_en}`;
              item.exh_begtime = `${item.exh_begtime_en}`;
              item.exh_endtime = `${item.exh_endtime_en}`;
              item.pay_time = `${item.pay_time_en}`;
              item.ascription_name = `${item.ascription_name_en}`;

            }
            item.exh_time = `${item.exh_begtime} ${this.language.to} ${item.exh_endtime}`;
            item.exhticket_price = `${item.exhticket_price}${this.language.CNY}/${this.language.site}`
            //角色
            switch (item.broadcast_type) {
              case "0":
                item.broadcastTypeName = this.language.compere;
                break;
              case "1":
                item.broadcastTypeName = this.language.guest + this.language.client;
                break;
              default:
                break;
            }
            //	门票类型
            switch (item.exhticket_type) {
              case "1":
                item.exhticketTypeName = this.language.oneSeat;
                break;
              case "2":
                item.exhticketTypeName = this.language.twoSeat;
                break;
              case "3":
                item.exhticketTypeName = this.language.threeSeat
                break;
              case "6":
                item.exhticketTypeName = this.language.threeSeat;
                break;
              case "999":
                item.exhticketTypeName = this.language.forum;
                break;
              default:
                break;
            }
          });
          this.ticktsData = data;
          this.cloneTicktsData = data;
          console.log("席位管理：" , data)
          this.pageTotal = Number(res.datacount);
          this.loading = false;
        } else {
          if (this.lan == "ch") {
            return this.$message.error({message: res.text, offset: 120})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    }
  }
};
</script>
<style scoped>
.prompt-info-text{
  margin: 10px 30px 10px 20px;
  width: 1058px;
  /*height: 50px;*/
  line-height: 50px;
  background-color: #f7f7f7;
  border-radius: 5px;
  text-align: left;
  padding-bottom: 10px;
}
.btnStyle {
  width: 120px;
  height: 40px;
  margin: auto;
  margin-top: 14px;
  line-height: 40px;
  background: #ff9e00;
  border: 0;
  color: #fff;
  border-radius: 5px;
  font-size: 14px;
}
  .tic_table {
   background: #ffffff;
    margin-top: 8px;
  }
  .tic_table .tableNode {
    background: #f7f7f7 !important;
    border-radius: 5px;
    width: 1058px;
    padding: 20px 70px 20px 25px !important;
    margin-left: 20px;
  }

  .prompt-infoword{
  height:30px;
  line-height:30px;
  font-family: SourceHanSansCN-Bold;
  padding-left:15px;
  color:#f47900;
  font-size:18px;
  font-weight:bold;
  padding-top:10px;
  border-radius: 5px;
}
.exhibitionRecord >>> .tableNode {
    margin-top: 8px;
    padding: 40px ;
    background: #fff;
    /*height: 482px;*/
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.exhibitionRecord >>> .tableNode .el-table{
  /*min-height: 400px;*/
  border: 1px solid #f2f2f2;
}
.exhibitionRecord >>> .tableNode .el-table th>.cell{
  border-right: none;
}
.exhibitionRecord >>> el-pagination {
  position: relative;
  left: -80px;
}
.exhibitionRecord >>> .el-pagination .el-pager li{
  width: 30px;
  height: 30px;
  line-height: 30px;
  background:none;
  font-size: 14px;
}
.exhibitionRecord >>> .el-pagination .btn-next{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: none;
}
.exhibitionRecord >>> .el-pagination .btn-prev{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: none;
}
.exhibitionRecord >>> .el-pagination .el-input__inner{
  width: 30px;
  height: 30px;
  line-height: 25px;
  margin-top: -15px !important;
}
.exhibitionRecord >>> .el-pagination .el-pagination__jump{
  width: 25px;
  height: 25px;
  line-height: 25px;
}
.exhibitionRecord >>> .el-pagination {
  position: relative;
  left: -80px;
}
.exhibitionRecord >>> .page-contfirm {
  position: relative;
  left: -20px;
}
.friendTip >>> .el-dialog__header {
  text-align: center;
  color: #333333;
  font-size: 24px;
  border: none;
  height: 30px !important;
}
.playback >>> .el-dialog__header,
.send-ticket >>> .el-dialog__header{
   border: none;
  height: 30px !important;
  line-height: 0;
}
.playback >>> .formCon,
.send-ticket >>> .formCon{
  padding-top: 10px;
}
.send-ticket >>> .el-dialog {
  border-radius: 10px;
}
.send-ticket >>> .el-form-item__label{
  font-size: 17px;
}
</style>
